export default {
  name: 'GlobusMixin',
  data() {
    const additionalRate2pc = 0.02
    const additionalRate3pc = 0.03
    const additionalRate5pc = 0.05
    return {
      globusParts: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      globusRates: [
        {
          parts: 4,
          value: 0.056 + additionalRate2pc,
        },
        {
          parts: 5,
          value: 0.068 + additionalRate2pc,
        },
        {
          parts: 6,
          value: 0.078 + additionalRate2pc,
        },
        {
          parts: 7,
          value: 0.09 + additionalRate3pc,
        },
        {
          parts: 8,
          value: 0.1 + additionalRate3pc,
        },
        {
          parts: 9,
          value: 0.11 + additionalRate3pc,
        },
        {
          parts: 10,
          value: 0.12 + additionalRate3pc,
        },
        {
          parts: 11,
          value: 0.132 + additionalRate5pc,
        },
        {
          parts: 12,
          value: 0.143 + additionalRate5pc,
        },
      ],
    }
  },
  methods: {
    onGlobusPaymentMethodChange() {
      if (!this.globusParts.includes(this.payParts.count)) {
        this.payParts.count = this.globusParts[0]
      }
    },
    onCheckoutGlobusPaymentMethodChange() {
      if (!this.globusParts.includes(this.partsCount)) {
        this.partsCount = this.globusParts[0]
      }
    },
  },
}
